module.exports = __webpack_public_path__ + "static/home-hero-1622d75dc3f654d5857e188f4f8fc448.mp4";